import { CloseOutlined, MinusSquareOutlined } from "@ant-design/icons";
import { Checkbox, Typography } from "antd";

const AliasCard = ({
  handleRemoveColumn,
  handleRequiredCheck,
  column,
  handleRemoveName,
  currentIndex,
}) => {
  return (
    <div className="outer_box">
      <div className="box_head">
        <CloseOutlined
          className="pointer delete_icon"
          style={{
            display: column.alias.toLowerCase() !== "barcode" || "none",
          }}
          onClick={() => handleRemoveColumn(currentIndex)}
        />

        <Typography.Text className="alias_head">{column.alias}</Typography.Text>
        <Checkbox
          defaultChecked={column.required}
          onChange={(e) => handleRequiredCheck(e.target.checked, currentIndex)}
        />
      </div>
      <div className="name_container">
        {column?.name?.map((item, i) => (
          <div key={i} className="name_box">
            <MinusSquareOutlined
              className="remove_icon pointer"
              onClick={() => handleRemoveName(currentIndex, i)}
            />
            <Typography.Text style={{ textAlign: "start" }}>
              {item}
            </Typography.Text>
          </div>
        ))}
      </div>
    </div>
  );
};
export default AliasCard;
